
    var riot = require('riot')
    //src: starling/src/tags/region-menu.html
riot.tag2('region-menu',
  '<div class="floating-menu_list" ref="floatingMenuEl"> <h3 class="floating-menu_list_title">{this.headerText()}</h3> <menu-item-edit-region-color canvas="{canvas}"></menu-item-edit-region-color> <menu-item-edit-region-title onmouseenter="{delayedHideSubMenus}" canvas="{canvas}"></menu-item-edit-region-title> <div class="floating-menu_divider"></div> <menu-item-add-comment if="{fromRightClick}"></menu-item-add-comment> <div class="floating-menu_divider" if="{fromRightClick}"></div> <menu-item-select-all onmouseenter="{delayedHideSubMenus}"></menu-item-select-all> <menu-item-paste if="{showPaste()}" onmouseenter="{delayedHideSubMenus}"></menu-item-paste> <menu-item-duplicate-region onmouseenter="{delayedHideSubMenus}"></menu-item-duplicate-region> <div if="{fromRightClick}" class="floating-menu_divider"></div> <menu-item-create-card if="{fromRightClick}"></menu-item-create-card> <menu-item-create-region if="{fromRightClick}"></menu-item-create-region> <div class="floating-menu_divider"></div> <menu-item-delete-region onmouseenter="{delayedHideSubMenus}" canvas="{canvas}"></menu-item-delete-region> </div>',
  '',
  'class="floating-menu {isOpen ? \'\' : \'floating-menu--hidden\'}"', function(opts) {
'use strict';

var _this = this;

var _menuUi = require('lib/menu-ui');

var _regionUi = require('lib/region-ui');

var _copyPaste = require('lib/copy-paste');

var _copyPaste2 = _interopRequireDefault(_copyPaste);

var _constants = require('lib/constants');

var _delayHandler = require('lib/delay-handler');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canvas = this.opts.canvas;

canvas.regionMenu = this;
this.canvas = canvas;
this.menuName = 'region-menu';
this.positionSelf = _menuUi.mui.positionSelf.bind(this);

this.summon = function (_ref) {
  var id = _ref.id,
      regionTag = _ref.regionTag,
      referenceEl = _ref.referenceEl,
      position = _ref.position,
      fromRightClick = _ref.fromRightClick;

  canvas.hidePopups();
  _this.isOpen = true;
  _this.fromRightClick = fromRightClick;
  _this.regionTag = regionTag;
  _this.x = position.x;
  _this.y = position.y;
  _this.id = id;
  _this.update();
  if (fromRightClick) {
    _this.positionSelf({ selfEl: _this.refs.floatingMenuEl, clickPosition: position });
  } else {
    _this.positionSelf({ referenceEl: referenceEl, selfEl: _this.refs.floatingMenuEl });
  }
};

this.hide = function () {
  delete _this.regionTag;
  _this.isOpen = false;
  _this.update();
};

this.delayedHideSubMenus = function (e) {
  if (e) {
    e.stopPropagation();
  }
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'hide',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      _this.hideSubMenus();
    }
  });
};

this.hideSubMenus = function () {
  if (canvas.menuItems['editRegionColor'].colorPickerVisible) {
    canvas.menuItems['editRegionColor'].closeColorPicker();
  }
};

this.showPaste = function () {
  return _this.fromRightClick && _copyPaste2.default.pasteContentExists();
};

this.getSelectedRegionIds = function () {
  var selectedRegionIds = _regionUi.regionUI.getSelectedRegionIdsArray();
  if (_this.regionTag) {
    if (!selectedRegionIds.includes(_this.regionTag.id)) {
      return [_this.regionTag.id];
    }
  }
  return selectedRegionIds;
};

this.headerText = function () {
  var numRegions = _this.getSelectedRegionIds().length;
  if (numRegions == 1) {
    return 'Region selected';
  }
  return numRegions + ' regions selected';
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('region-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/region-menu.html
// module id = 744
// module chunks = 0